import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'YesOrNo' })

///implements 
export class YesOrNoPipe implements PipeTransform {

  transform(value: boolean): string {
    return value == true ? "Yes" : "No";

  };
}
